export const firebaseConfig = {
  apiKey: "AIzaSyCxVIYQtI-qxSiq1OKGDAHgTASqiNJbefQ",
  authDomain: "notify-38b31.firebaseapp.com",
  projectId: "notify-38b31",
  storageBucket: "notify-38b31.firebasestorage.app",
  messagingSenderId: "648993315957",
  appId: "1:648993315957:web:f754e15434eaa6f1aeac3c"
};

